<template>
  <div class="payment-result">
    <div class="result-card">
      <div v-if="loading" class="loading">
        <div class="spinner"></div>
        <p>正在确认支付结果...</p>
      </div>

      <div v-else>
        <!-- 支付成功 -->
        <div v-if="status === '00' || status === 'completed'" class="success">
          <div class="icon">✅</div>
          <h2>支付成功</h2>
          <p>您的订单已完成支付！</p>
          <div class="details">
            <p v-if="orderId">订单号: {{ orderId }}</p>
            <p v-if="tranId">交易ID: {{ tranId }}</p>
          </div>
          <button @click="goHome" class="btn-primary">返回首页</button>
        </div>

        <!-- 支付失败 -->
        <div v-else class="failed">
          <div class="icon">❌</div>
          <h2>支付未完成</h2>
          <p>支付状态: {{ getStatusText(status) }}</p>
          <div class="details">
            <p v-if="orderId">订单号: {{ orderId }}</p>
          </div>
          <div class="actions">
            <button @click="retry" class="btn-primary">重新支付</button>
            <button @click="goHome" class="btn-secondary">返回首页</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentResult',
  data() {
    return {
      status: '',
      orderId: '',
      tranId: '',
      loading: true
    };
  },
  mounted() {
    // 获取URL参数
    const { status, orderId, tranId } = this.$route.query;
    this.status = status;
    this.orderId = orderId;
    this.tranId = tranId;
    
    // 如果没有直接的状态参数，尝试从后端查询
    if (!status && orderId) {
      this.checkPaymentStatus(orderId);
    } else {
      this.loading = false;
    }
  },
  methods: {
    async checkPaymentStatus(orderId) {
      try {
        const response = await this.$http.get('/fiuu/status/${orderId}');
        this.status = response.data.status === 'completed' ? '00' : 'failed';
        
        if (this.status === '00') {
          this.refreshUserInfo();
        }
        this.loading = false;
      } catch (e) {
        this.status = 'error';
        this.loading = false;
      }
    },
    async refreshUserInfo() {
        const userStr = localStorage.getItem('user');
        if (!userStr) return;
        const user = JSON.parse(userStr);
        try {
            const { data } = await this.$http.get('/user/info', {
                params: { username: user.username }
            });
            if (data.success) {
                localStorage.setItem('user', JSON.stringify(data.user));
            }
        } catch (e) { console.error('Failed to refresh user info', e); }
    },
    getStatusText(status) {
      const map = {
        '11': '支付失败',
        '22': '支付处理中',
        'error': '系统错误',
        'failed': '支付失败'
      };
      return map[status] || status;
    },
    goHome() {
      this.$router.push('/');
    },
    retry() {
      this.$router.push('/player');
    }
  }
}
</script>

<style scoped>
.payment-result {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a2e;
  padding: 20px;
}

.result-card {
  background: #16213e;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  color: #fff;
}

.icon {
  font-size: 64px;
  margin-bottom: 20px;
}

h2 {
  margin-bottom: 10px;
  color: #fff;
}

p {
  color: #aaa;
  margin-bottom: 20px;
}

.details {
  background: #0f3460;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 30px;
  text-align: left;
}

.details p {
  margin: 5px 0;
  font-size: 14px;
  font-family: monospace;
}

.btn-primary, .btn-secondary {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 10px;
}

.btn-primary {
  background: #e94560;
  color: #fff;
}

.btn-secondary {
  background: transparent;
  border: 1px solid #aaa;
  color: #aaa;
}

.loading .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #0f3460;
  border-top: 4px solid #e94560;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
